import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useWatch } from 'react-hook-form'
import { validateEmptyFields } from '../../helpers/util'
import InputSelectFieldGrid from 'components/common/InputSelectFieldGrid'
import { setErrorCodesProvider } from 'redux/slices/admin/providerSlice';
import { getProviderCredsErrorCodesService } from 'services/admin/providerService';
import { errorAlert } from 'helpers/alerts';
import CustomButton from 'components/CustomButton';

const BackupCodesProviderForm = ({ defaultValues, submit, validate }) => {
  const dispatch = useDispatch();
  const { control, handleSubmit } = useForm({ defaultValues });
  const watch = useWatch({ control });
  const [disabled, setDisabled] = useState(true);
  const { current, errorCodesProvider, backupCodesProvider } = useSelector(store => store.providers)

  useEffect(() => {
    getProviderCredsErrorCodesService(current.host)
      .then(response => dispatch(setErrorCodesProvider(response)))
      .catch(error => errorAlert(error));
  }, []);


  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <Grid container direction="column" justifyContent="center" alignItems="center" >
        <Grid container direction="column" m={"40px"} maxWidth={"40%"} justifyContent="center" alignItems="center" spacing={3}>
          <InputSelectFieldGrid
            name="code"
            label="Código del Proveedor"
            required="Debes seleccionar el código del proveedor"
            control={control}
            data={errorCodesProvider.filter(row => row.externalExceptionCode == defaultValues?.code || !backupCodesProvider.some(backup => backup.code === row.externalExceptionCode))}
            formatter={(rows) => rows.map((row) => ({
              id: row.externalExceptionCode,
              name: row.externalExceptionCode + ' - ' + row.hebeExceptionCode
            }))}
          />
        </Grid>
        <Grid item justifyContent="center" alignItems="center" >
          <CustomButton
            click={handleSubmit(submit)}
            disabled={disabled}
            name={"Guardar"}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default BackupCodesProviderForm